import { Suspense } from 'react';
import { Loader } from './Loader';
import { OverlayedLoader } from './OverlayedLoader';

interface SuspenseBoundaryProps {
    loader?: 'inline' | 'overlay';
}

export const SuspenseBoundary = ({ loader = 'overlay', children }: React.PropsWithChildren<SuspenseBoundaryProps>) => (
    <Suspense fallback={loader === 'inline' ? <Loader /> : <OverlayedLoader show />}>{children}</Suspense>
);
